import SchedulingRules from './SchedulingRules';

export default SchedulingRules;



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/Scheduling/Rules/index.js